import ProjectSession from "../../../../../../model2/project/project-session"
import {
    ProjectAccess,
    ProjectAccessDescriptionDictionary,
    ProjectAccessLabelDictionary
} from "../../../../../../gd/const/project"
import FieldsCollection from "../../../../../../fields3/collection/base/fields-collection"
import {FieldType} from "../../../../../../fields3/field-type"

export default function ProjectUser_initProjectTeamFields(projectId: ID) {
    const project: ProjectSession = gd.session.projects.get(projectId)!

    const customAccessOptions = !project.parentId ? [
        {value: ProjectAccess.FULL,         label: ProjectAccessLabelDictionary[ProjectAccess.FULL],        description: ProjectAccessDescriptionDictionary[ProjectAccess.FULL]},
        {value: ProjectAccess.STANDARD,     label: ProjectAccessLabelDictionary[ProjectAccess.STANDARD],    description: ProjectAccessDescriptionDictionary[ProjectAccess.STANDARD]},
        {value: ProjectAccess.LIMITED,      label: ProjectAccessLabelDictionary[ProjectAccess.LIMITED],     description: ProjectAccessDescriptionDictionary[ProjectAccess.LIMITED]},

        {value: ProjectAccess.CLIENT,       label: ProjectAccessLabelDictionary[ProjectAccess.CLIENT],      notSelectable: true},
        {value: ProjectAccess.READ_ONLY,    label: ProjectAccessLabelDictionary[ProjectAccess.READ_ONLY],   description: ProjectAccessDescriptionDictionary[ProjectAccess.READ_ONLY]},
    ] : undefined

    return new FieldsCollection([
        {
            fieldId : 'access',
            type    : FieldType.PROJECT_ACCESS,
            options : customAccessOptions
        },
    ])
}
